<div class="kanban">
  @for (col of filteredColumns(); track col.status) {
    <section class="kanban-col" [attr.data-status]="col.status">
      <header class="col-head">
        <span class="col-dot"></span>
        <span class="col-title">{{ statusLabel(col.status) }}</span>
        <span class="col-count">{{ col.total }}</span>
      </header>

      <div class="col-body">
        @for (p of col.visible; track p.id) {
          <a class="card" [routerLink]="['/properties', p.id]">
            <div class="card-title">{{ p.title }}</div>
            <div class="card-location">
              <i class="pi pi-map-marker"></i>
              {{ p.city || '—' }}{{ p.commune ? ', ' + p.commune : '' }}
            </div>
            <div class="card-chips">
              <span class="chip-type">{{ typeLabel(p.type) }}</span>
              <span class="chip-tx" [class.chip-tx--sale]="p.transactionType === 'VENTE'">
                {{ p.transactionType === 'VENTE' ? 'Vente' : 'Location' }}
              </span>
            </div>
            <div class="card-foot">
              <span class="card-price">{{ p.price | fcfa }}</span>
              <span class="card-date">{{ formatDate(p.createdAt) }}</span>
            </div>
            @if (col.status === 'REJECTED' && p.rejectionReason) {
              <div class="card-reason" [title]="p.rejectionReason">
                <i class="pi pi-exclamation-circle"></i> {{ p.rejectionReason }}
              </div>
            }
          </a>
        } @empty {
          @if (!col.loading) {
            <p class="col-empty">Aucun bien</p>
          }
        }

        @if (col.loading) {
          <div class="col-loading"><p-progress-spinner strokeWidth="5" [style]="{ width: '28px', height: '28px' }" /></div>
        } @else if (col.items.length < col.total) {
          <button pButton [text]="true" size="small" class="col-more"
                  icon="pi pi-angle-down" [label]="'Charger plus (' + (col.total - col.items.length) + ')'"
                  (click)="loadMore(col.status)"></button>
        }
      </div>
    </section>
  }
</div>
